import { DetailPage } from './detail-page';
import { NewDetailPage } from './new-detail-page';

export const DetailSwitchPage = (props) => {
  const { originURL, country, detail, locale, onBack, showDraft, darkMode, isShowroom } = props;

  if (!detail) return null;

  if (detail.isNewStructureId) {
    return (
      <NewDetailPage
        originURL={originURL}
        country={country}
        detail={detail}
        locale={locale}
        onBack={onBack}
        showDraft={showDraft}
        darkMode={darkMode}
        isShowroom={isShowroom}
      />
    );
  }

  return (
    <DetailPage
      originURL={originURL}
      country={country}
      detail={detail}
      locale={locale}
      onBack={onBack}
      showDraft={showDraft}
      darkMode={darkMode}
      isShowroom={isShowroom}
    />
  );
};
